import { PopularDestinationsState } from '@hotels/hotels-home/store/reducers/popular-destinations.reducer';
import { HotelsHomeUiModuleState as ui } from '@hotels/hotels-home/store/state/hotels-home-ui-module.state';
import { PopularHotelsState } from '@hotels/hotels-home/store/reducers/popular-hotels.reducer';
import { PopularPlacesState } from '@hotels/hotels-home/store/reducers/popular-places.reducer';

export const hotelsHomeFeatureName = 'hotelsHomeModuleState';

export type HotelsHomeModuleState = Readonly<{
  popularDestinations: PopularDestinationsState,
  popularHotels: PopularHotelsState,
  popularPlaces: PopularPlacesState,
  ui: ui
}>;
